import {
    FETCH_CARS,
    FETCH_CARS_SUCCESS,
    FETCH_CARS_FAILED,
    EDIT_CAR
  } from "../store/types";
  import store from '../store/store';
  import { firebase } from '../config/configureFirebase';
  import { onValue, update, set, child, remove, push, get } from "firebase/database";
  import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
  
  export const fetchCars = () => (dispatch) => {
  
    const {
        carsRef
    } = firebase;
  
    dispatch({
      type: FETCH_CARS,
      payload: null
    });

    const userInfo = store.getState().auth.profile;

    onValue(carsRef(userInfo.uid, userInfo.usertype), snapshot => {
      if (snapshot.val()) {
        let data = snapshot.val();
        const arr = Object.keys(data).map(i => {
          data[i].id = i;
          return data[i]
        });
        dispatch({
          type: FETCH_CARS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_CARS_FAILED,
          payload: store.getState().languagedata.defaultLanguage.no_cars
        });
      }
    });
  };
  
  export const editCar = (car, method) => async (dispatch) => {
    const {
      singleUserRef,
      carAddRef, 
      carEditRef,
      carImage,
      carRegistrationImage,
      carInsuranceImage
    } = firebase;
    dispatch({
      type: EDIT_CAR,
      payload: { method, car }
    });
    if (method === 'Add') {
        push(carAddRef, car);
    } else if (method === 'Delete') {
        remove(carEditRef(car.id));
    } else if (method === 'UpdateImage') {
      let data = { ...car };
      if (data.tableData) {
        delete data.tableData;
      }

      let existingCar = {};
      try {
        const snap = await get(carEditRef(car.id));
        if (snap.exists()) {
          existingCar = snap.val() || {};
        }
      } catch (err) {
        console.error("Error fetching existing car in UpdateImage:", err);
      }

      const uploadAndGetURL = async (fileOrBlob, storageRefFunc, id) => {
          if (fileOrBlob && typeof fileOrBlob !== 'string') {
              const metadata = { contentType: 'image/jpeg' };
              await uploadBytesResumable(storageRefFunc(id), fileOrBlob, metadata);
              if (fileOrBlob.close) {
                fileOrBlob.close();
              }
              return await getDownloadURL(storageRefFunc(id));
          }
          return fileOrBlob; 
      };

      let image = existingCar.car_image || null;
      if (car.car_image && typeof car.car_image !== 'string') {
        image = await uploadAndGetURL(car.car_image, carImage, car.id);
      } else if (typeof car.car_image === 'string' && car.car_image.trim() !== '') {
        image = car.car_image;
      }

      let regImage = existingCar.car_registration_image || null;
      if (car.car_registration_image && typeof car.car_registration_image !== 'string') {
        regImage = await uploadAndGetURL(car.car_registration_image, carRegistrationImage, car.id);
      } else if (typeof car.car_registration_image === 'string' && car.car_registration_image.trim() !== '') {
        regImage = car.car_registration_image;
      }

      let insImage = existingCar.car_insurance_image || null;
      if (car.car_insurance_image && typeof car.car_insurance_image !== 'string') {
        insImage = await uploadAndGetURL(car.car_insurance_image, carInsuranceImage, car.id);
      } else if (typeof car.car_insurance_image === 'string' && car.car_insurance_image.trim() !== '') {
        insImage = car.car_insurance_image;
      }

      if (image) data.car_image = image;
      else if (existingCar.car_image) data.car_image = existingCar.car_image;

      if (regImage) data.car_registration_image = regImage;
      else if (existingCar.car_registration_image) data.car_registration_image = existingCar.car_registration_image;

      if (insImage) data.car_insurance_image = insImage;
      else if (existingCar.car_insurance_image) data.car_insurance_image = existingCar.car_insurance_image;
      
      await update(carEditRef(car.id), data);
      
      if(car.active && car.driver){
        update(singleUserRef(car.driver), {
          updateAt: new Date().getTime(),
          car_image: data.car_image || image
        });
      }   
    }
     else if (method === 'Update') {
      let data = { ...car };
      if (data.tableData) {
        delete data.tableData;
      }
      await update(carEditRef(car.id), data);
    }
     else {
      let data = { ...car };
      if (data.tableData) {
        delete data.tableData;
      }
      await update(carEditRef(car.id), data);
    }
  }

  export const updateUserCarWithImage = (newData, blobs) => async (dispatch) => {
    const {
      auth,
      carAddRef,
      carEditRef,
      singleUserRef,
      carImage,
      carRegistrationImage,
      carInsuranceImage
    } = firebase;

    var carId = newData.id || push(carAddRef).key;
    if (!newData.id) {
        newData.id = carId;
    }

    let existingCar = {};
    if (newData.id) {
      try {
        const snap = await get(carEditRef(newData.id));
        if (snap.exists()) {
          existingCar = snap.val() || {};
        }
      } catch (err) {
        console.error("Error fetching existing car in updateUserCarWithImage:", err);
      }
    }
    
    const uploadAndGetURL = async (fileOrBlob, storageRefFunc, id) => {
        if (fileOrBlob && typeof fileOrBlob !== 'string') {
            const metadata = { contentType: 'image/jpeg' };
            await uploadBytesResumable(storageRefFunc(id), fileOrBlob, metadata);
            if (fileOrBlob.close) {
              fileOrBlob.close();
            }
            return await getDownloadURL(storageRefFunc(id));
        }
        return fileOrBlob; 
    };

    let image = existingCar.car_image || null;
    if (blobs && blobs.car_image && typeof blobs.car_image !== 'string') {
      image = await uploadAndGetURL(blobs.car_image, carImage, carId);
    } else if (blobs && typeof blobs.car_image === 'string' && blobs.car_image.trim() !== '') {
      image = blobs.car_image;
    }

    let regImage = existingCar.car_registration_image || null;
    if (blobs && blobs.car_registration_image && typeof blobs.car_registration_image !== 'string') {
      regImage = await uploadAndGetURL(blobs.car_registration_image, carRegistrationImage, carId);
    } else if (blobs && typeof blobs.car_registration_image === 'string' && blobs.car_registration_image.trim() !== '') {
      regImage = blobs.car_registration_image;
    }

    let insImage = existingCar.car_insurance_image || null;
    if (blobs && blobs.car_insurance_image && typeof blobs.car_insurance_image !== 'string') {
      insImage = await uploadAndGetURL(blobs.car_insurance_image, carInsuranceImage, carId);
    } else if (blobs && typeof blobs.car_insurance_image === 'string' && blobs.car_insurance_image.trim() !== '') {
      insImage = blobs.car_insurance_image;
    }

    if (image) newData.car_image = image;
    else if (existingCar.car_image) newData.car_image = existingCar.car_image;

    if (regImage) newData.car_registration_image = regImage;
    else if (existingCar.car_registration_image) newData.car_registration_image = existingCar.car_registration_image;

    if (insImage) newData.car_insurance_image = insImage;
    else if (existingCar.car_insurance_image) newData.car_insurance_image = existingCar.car_insurance_image;
    
    if (newData.id && existingCar && Object.keys(existingCar).length > 0) {
      await update(carEditRef(carId), newData);
    } else {
      await set(child(carAddRef, carId), newData);
    }
    
    if(newData.active){
      let updateData = {
        carType: newData.carType,
        category: newData.category,
        vehicleNumber: newData.vehicleNumber,
        vehicleMake: newData.vehicleMake,
        vehicleModel: newData.vehicleModel,
        car_color: newData.car_color || newData.vehicle_color || "",
        vehicle_color: newData.car_color || newData.vehicle_color || "",
        other_info: newData.other_info,
        car_image: image || newData.car_image,
        carApproved: newData.approved,
        updateAt: new Date().getTime(),
        activeCar_position: newData.activeCar_position,
        unit_type: newData.unit_type,
        capacity: newData.capacity ? newData.capacity : 0
      };
      update(singleUserRef(auth.currentUser.uid), updateData);
    }
  };


  export const deleteUsersAllcars = async(userId) =>{
    const {
      carsRef,
      carEditRef
    } = firebase;

    try {
      const snapshot = await get(carsRef(userId, null));
      if (snapshot.exists()) {
        let data = snapshot.val();
        if (data) {
          const carsToDelete = Object.keys(data)
            .filter((key) => data[key].driver === userId)
            .map((key) => {
              data[key].id = key;
              return data[key];
            });
          for (const car of carsToDelete) {
            await remove(carEditRef(car.id));
          }
        }
      }
    } catch (error) {
      console.error("Failed to delete user cars:", error);
    }
  }